import { useEffect, useState } from "react";

export default function ViewJournalModal({ journalId, onClose }) {
  const [journal, setJournal] = useState(null);

  useEffect(() => {
    fetch(`/api/journal/${journalId}`, {
      credentials: "include",
    })
      .then((r) => r.json())
      .then((data) => {
        setJournal(data);
      })
      .catch(console.error);
  }, [journalId]);

  if (!journal) {
    return (
      <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-50">
        Loading...
      </div>
    );
  }

  const totalDebit = (journal.items || []).reduce(
    (sum, item) => sum + Number(item.debit || 0),
    0,
  );

  const totalCredit = (journal.items || []).reduce(
    (sum, item) => sum + Number(item.credit || 0),
    0,
  );

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex justify-center items-center z-50">
      <div className="w-full max-w-5xl rounded-2xl bg-[#09090B] border border-white/10">
        <div className="flex justify-between items-center px-8 py-5 border-b border-white/10">
          <div>
            <h2 className="text-2xl font-serif">Journal Details</h2>

            <p className="text-gray-400 text-sm">{journal.entry_no}</p>
          </div>

          <button onClick={onClose} className="text-xl">
            ✕
          </button>
        </div>

        <div className="p-8 space-y-6">
          <div className="grid md:grid-cols-3 gap-5">
            <div>
              <label className="text-xs text-gray-400">Date</label>

              <div className="mt-2">{journal.entry_date}</div>
            </div>

            <div>
              <label className="text-xs text-gray-400">Reference</label>

              <div className="mt-2">{journal.reference || "-"}</div>
            </div>

            <div>
              <label className="text-xs text-gray-400">Narration</label>

              <div className="mt-2">{journal.narration || "-"}</div>
            </div>
          </div>

          <table className="w-full">
            <thead>
              <tr className="text-gray-400">
                <th className="text-left py-3">Account</th>

                <th className="text-right">Debit</th>

                <th className="text-right">Credit</th>
              </tr>
            </thead>

            <tbody>
              {journal.items?.map((item, index) => (
                <tr key={index} className="border-t border-white/10">
                  <td className="py-3">{item.account}</td>

                  <td className="text-right">
                    ₹{Number(item.debit).toLocaleString("en-IN")}
                  </td>

                  <td className="text-right">
                    ₹{Number(item.credit).toLocaleString("en-IN")}
                  </td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr className="border-t border-white/20 font-semibold">
                <td className="py-4">Total</td>

                <td className="text-right text-emerald-400">
                  ₹{totalDebit.toLocaleString("en-IN")}
                </td>

                <td className="text-right text-indigo-400">
                  ₹{totalCredit.toLocaleString("en-IN")}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
}
